import { render, staticRenderFns } from "./AddressData.vue?vue&type=template&id=22bca48d&scoped=true"
import script from "./AddressData.vue?vue&type=script&lang=js"
export * from "./AddressData.vue?vue&type=script&lang=js"
import style0 from "./AddressData.vue?vue&type=style&index=0&id=22bca48d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bca48d",
  null
  
)

export default component.exports